import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken, getTokenRole } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  tokenRole:  getTokenRole(),
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  companyName: '',
  roles: []
}

const mutations = {
  SET_TOKEN_ROLE: (state,token) => {
    state.tokenRole = token
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_IS_SUPER: (state, i) => {
    // 设置是否为超级管理员
    state.isSuper = i
  },
  SET_MENU: (state, i) => {
    // 管理员菜单
    state.menu = i
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_COMPANY_NAME: (state, companyName) => {
    state.companyName = companyName
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        commit('SET_TOKEN', response.tokencool)
        commit('SET_TOKEN_ROLE', response.tokenrole)
        setToken(response.tokencool,response.tokenrole)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.tokenRole).then(response => {
        const data = {
          roles: response.data.info.roles,
          introduction: response.data.info.description,
          avatar: response.data.info.avatar,
          name: response.data.info.name,
          isSuperAdmin: response.data.info.isSuper,
          companyName: response.data.info.xname,
          menu: []
        }
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { roles, name, avatar, introduction, isSuperAdmin, menu,companyName } = data

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        // 把 是否为超级管理员保存到 vuex中
        commit('SET_IS_SUPER', isSuperAdmin)
        // 把 菜单JSON数组 保存到 vuex中
        commit('SET_COMPANY_NAME',companyName)
        commit('SET_MENU', menu)

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {

      commit('SET_TOKEN', '')
      commit('SET_TOKEN_ROLE','')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()

      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    }).catch(error => {
      reject(error)

    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
